<template>
  <NuxtLink :to="'/'+item.path" class="link-unstyled w-full flex px-2 justify-between items-center h-12 rounded hover:bg-grey-50 active:bg-grey-100">
    <span :class="nameClass" class="font-medium flex-1 text-left truncate">
      {{ item.name }}
    </span>
    <ArrowRightIcon
      v-if="item.children.length && item.children.some((c: CategoryTreeItem) => c.isIncludedInMenu)"
      aria-hidden="true"
      class="size-6 mx-4 opacity-30"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
import { ArrowRightIcon } from '@heroicons/vue/24/outline'
import type { CategoryTreeItem } from '~/types/category'

defineProps({
  item: {
    type: Object as () => CategoryTreeItem,
    required: true
  },
  nameClass: {
    type: String,
    default: ''
  }
})
</script>
